import uuid from "uuid";

export const GetNewId = () => {
    return uuid.v4();
}